import { memo } from "react";
import { Link } from "react-router-dom";
import { ChangeAvatar } from "./accountSections/avatar";
import { DisableComments } from "MVVM/Views/DisableComments";
import { EmailAddress } from "./accountSections/emailAddress";
import { ResetPassword } from "./accountSections/resetPassword";
import { CustomizeProfile } from "../../MVVM/Views/Account/Components/ConnectedAccounts";
import { UsernameChange } from "../../MVVM/Views/ProfileSettings/UpdateUsername";
import { DeleteAccount } from "../../MVVM/Views/Account/Components/DeleteAccount";
import { ClipQuotaBar } from "../../MVVM/Components/ClipQuotaBar";
import { SettingsContainer } from "../../components/molecules/settingsContainer";
import { Button } from "MVVM/Components/Button";
import { URLS } from "MVVM/Utilities/Maps";

const AccountSettings = memo(({ allstarUser, getFreshProfile }) => {
  return (
    <>
      <ChangeAvatar
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
      <SettingsContainer title="Clip Usage" mb={5} subtitle={undefined}>
        <ClipQuotaBar
          clipQuota={allstarUser?.user?.clipQuota}
          userEmail={allstarUser?.decoded?.sub}
        />
        <Link to={URLS.CLIP_SETTINGS}>
          <Button
            size="small"
            classification="secondary"
            style={{ marginTop: 16, width: "fit-content" }}
          >
            Manage Clipping Settings
          </Button>
        </Link>
      </SettingsContainer>
      <UsernameChange
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
      <CustomizeProfile
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />

      <EmailAddress
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
      <ResetPassword
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
      <DisableComments
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
      <DeleteAccount
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
      />
    </>
  );
});

export { AccountSettings };
